var React = require('react');

function ChevronLeft48Px (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0L48 0 48 48 0 48z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M30.82 14.82L28 12 16 24 28 36 30.82 33.18 21.66 24z","key":1})]));
}

ChevronLeft48Px.defaultProps = {"fill":"currentColor","width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = ChevronLeft48Px;

ChevronLeft48Px.default = ChevronLeft48Px;
